import { css } from 'lit';

var css_248z = css`.sr-only{clip:rect(0,0,0,0);border:0;height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}`;

export { css_248z as default };
//# sourceMappingURL=sgds-spinner2.js.map
